var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fa-layers',{staticClass:"fa-lg",class:{ 'hidden-button': !_vm.visible },on:{"click":function($event){_vm.visible ? _vm.$emit('click') : undefined}}},[_c('fa-icon',{attrs:{"icon":"circle"}}),_vm._v(" "),_c('fa-icon',{style:({ color: 'white' }),attrs:{"icon":['far', 'trash-alt'],"transform":"shrink-6"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }